import { getAppProps } from '@/Navigation';
import yoda from '@kibt/bridge';

export function checkNativeNavbar() {
    const launchOptions = getAppProps().__launch_options__;
    if (launchOptions) {
        try {
            const { topBarPosition } = JSON.parse(decodeURIComponent(launchOptions));
            if (topBarPosition === 'fixed') {
                yoda.ui.setTopBarStyle({ position: 'fixed' });
            }
        } catch (e) {
            console.error('checkNativeNavbar error', e);
        }
    }
}
